export default function AddSquareIcon() {
  return (
    <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5.93848 8H11.1777" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M8.55762 10.6673V5.33398" strokeLinecap="round" strokeLinejoin="round"/>
      <path
        d="M6.5931 14.6673H10.5225C13.797 14.6673 15.1068 13.334 15.1068 10.0007V6.00065C15.1068 2.66732 13.797 1.33398 10.5225 1.33398H6.5931C3.31859 1.33398 2.00879 2.66732 2.00879 6.00065V10.0007C2.00879 13.334 3.31859 14.6673 6.5931 14.6673Z"
        strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
